// @file Expanded post store
import { getVuexStore } from '@@/bits/pinia'
import type { Cid } from '@@/types'
import type { RootState } from '@@/vuexstore/surface/types'
import { defineStore } from 'pinia'
import { computed } from 'vue'

export const useExpandedPostStore = defineStore('expandedPost', () => {
  const surfaceVuexStore = getVuexStore<RootState>()

  const xExpandedPostTextPanel = computed<boolean>(() => surfaceVuexStore?.getters['postAction/xExpandedPostTextPanel'])
  const expandedPostCid = computed<Cid>(() => surfaceVuexStore?.getters['postAction/expandedPostCid'])

  return {
    xExpandedPostTextPanel,
    expandedPostCid,
  }
})
